export default {"src":"/_next/static/media/goal-with-trees.c232999b.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};